import Model from "./model";

/* eslint-disable no-unused-expressions */
class BillingAddress extends Model {
  constructor() {
    super();

    this._companyName = "";
    this._personInChargeName = "";
    this._postalCode = "";
    this._state = "";
    this._town = "";
    this._street = "";
    this._building = "";
    this._phoneNumber = "";
  }

  get companyName() {
    return this._companyName;
  }

  set companyName(value) {
    this._companyName = value;
  }

  get personInChargeName() {
    return this._personInChargeName;
  }

  set personInChargeName(value) {
    this._personInChargeName = value;
  }

  get postalCode() {
    return this._postalCode;
  }

  set postalCode(value) {
    this._postalCode = value;
  }

  get state() {
    return this._state;
  }

  set state(value) {
    this._state = value;
  }

  get town() {
    return this._town;
  }

  set town(value) {
    this._town = value;
  }

  get street() {
    return this._street;
  }

  set street(value) {
    this._street = value;
  }

  get building() {
    return this._building;
  }

  set building(value) {
    this._building = value;
  }

  get phoneNumber() {
    return this._phoneNumber;
  }

  set phoneNumber(value) {
    this._phoneNumber = value;
  }

  getAddressText() {
    let addressText = `${this._state}${this._town}${this._street}${this._building}${this._phoneNumber}`;
    if (!addressText) addressText = "";
    return addressText;
  }

  json() {
    return {
      companyName: this._companyName,
      personInChargeName: this._personInChargeName,
      postalCode: this._postalCode,
      state: this._state,
      town: this._town,
      street: this._street,
      building: this._building,
      phoneNumber: this._phoneNumber,
    };
  }
}

class PaymentInfo extends Model {
  constructor() {
    super();

    this._paymentMethod;
  }

  get paymentMethod() {
    return this._paymentMethod;
  }

  set paymentMethod(value) {
    this._paymentMethod = value;
  }

  json() {
    return {
      paymentMethod: this._paymentMethod,
    };
  }
}

class ServiceAccount extends Model {
  constructor() {
    super();

    this._serviceAccountId;
    this._serviceAccountName;
    this._contractUserId;
    this._contractUserEmail;
    this._contractUserName;

    this._billingAddress;
    this._paymentInfo;
  }

  get serviceAccountId() {
    return this._serviceAccountId;
  }

  set serviceAccountId(value) {
    this._serviceAccountId = value;
  }

  get serviceAccountName() {
    return this._serviceAccountName;
  }

  set serviceAccountName(value) {
    this._serviceAccountName = value;
  }

  get contractUserId() {
    return this._contractUserId;
  }

  set contractUserId(value) {
    this._contractUserId = value;
  }

  get contractUserEmail() {
    return this._contractUserEmail;
  }

  set contractUserEmail(value) {
    this._contractUserEmail = value;
  }

  get contractUserName() {
    return this._contractUserName;
  }

  set contractUserName(value) {
    this._contractUserName = value;
  }

  get billingAddress() {
    return this._billingAddress;
  }

  set billingAddress(value) {
    this._billingAddress = value;
  }

  get paymentInfo() {
    return this._paymentInfo;
  }

  set paymentInfo(value) {
    this._paymentInfo = value;
  }

  json() {
    const res = {
      serviceAccountId: this._serviceAccountId,
      serviceAccountName: this._serviceAccountName,
      contractUserId: this._contractUserId,
      contractUserEmail: this._contractUserEmail,
      contractUserName: this._contractUserName,
    };

    if (this._billingAddress instanceof BillingAddress) {
      res.billingAddress = this._billingAddress.json();
    }

    if (this._paymentInfo instanceof PaymentInfo) {
      res.paymentInfo = this._paymentInfo.json();
    }
    return res;
  }
}

export {
  BillingAddress,
  PaymentInfo,
  ServiceAccount,
};
